
import Session from "./sessionStorage";


export function getUserProfile() {
  const profile = Session.get("profile");
  return profile ? JSON.parse(profile) : null;
}


export function getOfferCode() {
  const profile = getUserProfile();
  return profile?.offerCode || null;
}

export function isAddPlanDisabled() {
  const offerCode = getOfferCode();

  const restrictedOffers = ["One-X Offer"]; 

  return restrictedOffers.includes(offerCode);
}
